module.exports = __webpack_public_path__ + "img/Virtual Assistant T950.e50dad6b.png";